import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
// import TeamMemberArchiveUserModal from '../../containers/station-user/TeamMemberArchiveUserModal'
import StationUserCreateForm from '../../containers/station-user/StationUserCreateForm'
// import TeamMemberResetPasswordModal from '../../containers/station-user/TeamMemberResetPasswordModal'
// import TeamMemberSendInviteModal from '../../containers/station-user/TeamMemberSendInviteModal'
import StationUserTablePane from '../../containers/station-user/StationUserTablePane'
import StationUserViewPane from '../../containers/station-user/StationUserViewPane'
import ErrorBoundary from '../ErrorBoundary'

const StationUserTableRoute = () => <StationUserTablePane />

const StationUserListPane = ({ match }: RouteComponentProps<{}>) => {
  return (
    <div>
      <Route exact={true} path={match.path} component={StationUserTableRoute} />
      {/* <Route path={`${match.path}/:id/archive`} component={TeamMemberArchiveUserModal} /> */}
      {/* <Route path={`${match.path}/:id/reset-password`} component={TeamMemberResetPasswordModal} /> */}
      {/* <Route path={`${match.path}/:id/send-invite`} component={TeamMemberSendInviteModal} /> */}
    </div>
  )
}

const StationUserPane = ({ match }: RouteComponentProps<{}>) => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${match.path}/create`} component={StationUserCreateForm} />
        <Route path={`/station-user/edit/:id`} component={StationUserCreateForm} />
        <Route path={`${match.path}/:id`} component={StationUserViewPane} />
        <Route exact={true} path={`${match.path}`} component={StationUserListPane} />
      </Switch>
    </ErrorBoundary>
  )
}

export default StationUserPane



// WEBPACK FOOTER //
// ./src/components/station-user/StationUserPane.tsx